import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const sentryWeb: PluginWebManifest = {
  routes: [
    {
      path: '/configure/connect/integrations/sentry/:projectId',
      componentPath: '@reflex/plugin-sentry/web/SentryProjectDetailPage',
    },
  ],
  // Mounted in both the wizard slide-over and the plugin detail page.
  orgSetupComponent: {
    componentPath: '@reflex/plugin-sentry/web/SentryPage',
    label: 'Generate a Sentry token and add it as a per-org connection.',
  },
  // Searchable `@sentry:` category in the launch and chat composers. The
  // matching server resolver is registered in `index.ts` under the same kind.
  agentContextProviders: [
    {
      id: 'agent-context-sentry-issues',
      kind: 'sentry-issue',
      label: 'Sentry issues',
      keyword: 'sentry',
      icon: 'Bug',
      componentPath: '@reflex/plugin-sentry/web/SentryIssueContextProvider',
      order: 80,
    },
  ],
  flowTriggerRenderers: [
    {
      triggerType: 'sentry_issue',
      label: 'Sentry issue',
      icon: 'Bug',
      componentPath: '@reflex/plugin-sentry/web/SentryFlowTriggerSummary',
    },
  ],
  marketingPreviews: [
    {
      id: 'sentry-projects',
      label: 'Sentry projects panel',
      description:
        'Connected workspace, monitored Sentry projects mapped to personas, and recent issue runs.',
      surface: 'panel',
      componentPath: '@reflex/plugin-sentry/web/SentryPagePreview',
    },
  ],
};
